import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import DebtorContactModal from './DebtorContactModal';

const DebtorContactPage = () => {
    const { id, document } = useParams<{ id: string; document: string }>();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    return (
        <DebtorContactModal
            show={true}
            onClose={() => navigate(`/collateral/drawee-confirmation/${id}/receivables`)}
            contactId={searchParams.get('contactId') || undefined}
            debtorName={searchParams.get('name') || ''}
            debtorDocument={document || ''}
            receivables={[]}
            operationId=""
        />
    );
};

export default DebtorContactPage;
